import type { ClientApplication } from '../../client';
import type { BlurayLookupService } from './bluray-lookup';

export const blurayLookupPath = 'api/bluray-lookup';

export const blurayLookupMethods = ['find'] as const;

export interface BlurayLookupQuery {
  tmdb_id?: string | number;
  imdb_id?: string;
  title?: string;
  year?: number | string;
}

export interface BlurayLookupResult {
  title: string;
  year: number | string;
  url: string;
  best_available_format: string | null;
  best_video: string | null;
  best_audio: string | null;
  best_english_friendly: string | null;
  /** The write-up behind each pick (the pick fields hold only release names). */
  best_video_notes: string | null;
  best_audio_notes: string | null;
  best_english_friendly_notes: string | null;
  upcoming_release: string | null;
  additional_info: string | null;
}

export type BlurayLookupClientService = Pick<
  BlurayLookupService,
  (typeof blurayLookupMethods)[number]
>;

export const blurayLookupClient = (client: ClientApplication) => {
  const connection = client.get('connection');

  client.use(blurayLookupPath, connection.service(blurayLookupPath), {
    methods: blurayLookupMethods,
  });
};

// Add this service to the client service type index
declare module '../../client' {
  interface ServiceTypes {
    [blurayLookupPath]: BlurayLookupClientService;
  }
}
